<p-toast position="top-right"></p-toast>
<p-confirmDialog #cd [style]="{width: '600px'}">
  <p-footer>
    <button type="button" pButton accesskey="d" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Delete" (click)="cd.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>

<div style="height:100%;">
  <p-toolbar>
    <div class="p-toolbar-group-left">
      <p-breadcrumb [model]="items" class="p-d-none p-d-lg-inline"></p-breadcrumb>
      <span style="padding-top:2px;">
        <button pButton type="button" 
                class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
                icon="pi pi-fw pi-refresh" 
                (click)="loadData()"></button>

        <!-- Display only on bigger than md screens-->
        <span class="p-d-none p-d-md-inline">
          <button pButton type="button" 
                  class="p-button p-button-text" 
                  label="Add Company" 
                  icon="pi-fw fas fa-city"
                  (click)="addEmployer()"></button>
        </span>

        <!-- Display only on smaller than md screens-->
        <span class="p-d-md-none">
          <button pButton type="button" 
                  class="p-button-rounded"  
                  icon="pi-fw fas fa-city"
                  (click)="addEmployer()"></button>
        </span>

      </span>
    </div>

    <div class="p-toolbar-group-right">
      <i class="pi-fw far fa-bell p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon" pBadge 
         style="color: var(--green-600)" 
         severity="danger"
         pTooltip="Total Number of Company: {{employers.length}}"
         value="{{employers.length}}"></i>
    </div>
  </p-toolbar>

  <div style="height: calc(100% - 36px); width:100%;">
    <ngx-spinner bdColor="rgba(128, 128, 128, 0.8)"
                 size="default"
                 color="#2f9cf2"
                 type="line-scale-pulse-out"
                 [name]="spinnerName"
                 [fullScreen]="false">

      <p style="color:white" >Loading company data ... </p>
    </ngx-spinner>

    <ag-grid-angular
        *ngIf="employers.length > 0"
        style="width: 100%; height:100%;"
        class="ag-theme-alpine"
        rowSelection="single"
        [gridOptions]="gridOptions"
        [context]="context"
        [rowData]="employers"
        [columnDefs]="gridHeaders"
        [enterMovesDown]="true"
        [enterMovesDownAfterEdit]="true"
        (gridReady)="onGridReady($event)"></ag-grid-angular>
  </div>
</div>
